import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["questionKey"];
import ProductInfoContainer from 'pricing-pages-lib/js/components/ProductInfoContainer.tsx';
import { PPUIPageHeader } from 'pricing-pages-ui-components/semantic/PageHeader';
import { PageSection } from 'pricing-pages-ui-components/semantic/PageSection';
import { useQueryParamTerm, useQueryParamsEffect } from 'pricing-pages-ui/utils/urls/appQueryParamUtils';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { NavMarker } from 'react-rhumb';
import { BUNDLE } from 'self-service-api/constants/UpgradeProducts';
import WhyGoHubSpotSection from '../components/WhyGoHubSpotSection';
import BannerSection from '../components/banners/BannerSection';
import IntegrationsSection from '../components/common/IntegrationsSection';
import PhoneSupport from '../components/common/PhoneSupport';
import PhoneSupportFooter from '../components/common/PhoneSupportFooter';
import ProductPageSubtitle from '../components/common/ProductPageSubtitle';
import ProductPageTitle from '../components/common/ProductPageTitle';
import CodeSplitEnvWrapper from '../components/common/env/CodeSplitEnvWrapper';
import FailedLoadBanner from '../components/common/loading/FailedLoadBanner';
import FallbackErrorBanner from '../components/common/loading/FallbackErrorBanner';
import Faq from '../components/faqs/Faq';
import FooterMicrocopy from '../components/faqs/FooterMicrocopy';
import Question from '../components/faqs/Question';
import MobileCurrencyPicker from '../components/mobile/MobileCurrencyPicker';
import MobileDropdownNav from '../components/mobile/MobileDropdownNav';
import MobileSuiteTileContainer from '../components/mobile/MobileSuiteTileContainer';
import { FaqsConfig } from '../constants/faqs/FaqsConfig';
import { NavItemEnum } from '../constants/routing/NavItems';
import { SCREENS } from '../constants/tracking/Screens';
import { useAnchorLinkScroll } from '../hooks/htmlElementHooks';
import { useGlobalLoading } from '../hooks/loadingHooks';
import { useDocumentTitle } from '../hooks/useDocumentTitle';
import { useTrackRetail } from '../hooks/useTrackRetail';
import { hasPricingAndPurchasingFailedSelector } from '../selectors/LoadingStateSelectors';
import { trackPageView } from '../utils/tracking/trackingEventUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const MobileSuitePage = () => {
  useAnchorLinkScroll();
  useTrackRetail();
  useDocumentTitle('crmSuite');
  const screen = SCREENS.SUITE;
  const isAppReady = useGlobalLoading();
  const hasPricingAndPurchasingFailed = useSelector(hasPricingAndPurchasingFailedSelector);
  useEffect(() => {
    trackPageView({
      screen
    });
  }, [screen]);
  const {
    queryParamTerm
  } = useQueryParamTerm();
  useQueryParamsEffect({
    term: queryParamTerm
  });
  return /*#__PURE__*/_jsxs("div", {
    children: [isAppReady && /*#__PURE__*/_jsx(NavMarker, {
      name: "SUITE_PAGE"
    }), /*#__PURE__*/_jsx(MobileCurrencyPicker, {}), /*#__PURE__*/_jsx(MobileDropdownNav, {
      selectedNavItem: NavItemEnum.SUITE
    }), /*#__PURE__*/_jsxs(ProductInfoContainer, {
      children: [/*#__PURE__*/_jsx(BannerSection, {
        screen: screen
      }), /*#__PURE__*/_jsx(FailedLoadBanner, {
        hasFailed: hasPricingAndPurchasingFailed
      }), /*#__PURE__*/_jsx(FallbackErrorBanner, {}), /*#__PURE__*/_jsxs(PPUIPageHeader, {
        children: [/*#__PURE__*/_jsx(ProductPageTitle, {
          nonProductIdentifier: NavItemEnum.SUITE
        }), /*#__PURE__*/_jsx(ProductPageSubtitle, {
          nonProductIdentifier: NavItemEnum.SUITE
        })]
      }), /*#__PURE__*/_jsx(MobileSuiteTileContainer, {
        screen: screen
      }), /*#__PURE__*/_jsx(PageSection, {
        children: /*#__PURE__*/_jsx(PhoneSupport, {
          phoneSourceId: "crmsuite-middle",
          screen: screen,
          upgradeProduct: BUNDLE
        })
      }), /*#__PURE__*/_jsx(WhyGoHubSpotSection, {
        selectedNavItem: NavItemEnum.SUITE
      }), /*#__PURE__*/_jsx(IntegrationsSection, {}), /*#__PURE__*/_jsx(CodeSplitEnvWrapper, {
        publicComponentLoader: () => import( /* webpackChunkName: "public-chunk" */`pricing-pages-ui/components/company-proof/CompanyProof`),
        publicComponentProps: {
          tab: 'enterprise'
        }
      }), /*#__PURE__*/_jsxs(Faq, {
        children: [FaqsConfig[NavItemEnum.SUITE].map(_ref => {
          let {
              questionKey
            } = _ref,
            passthroughOptions = _objectWithoutPropertiesLoose(_ref, _excluded);
          return /*#__PURE__*/_jsx(Question, Object.assign({
            questionKey: questionKey
          }, passthroughOptions), questionKey);
        }), /*#__PURE__*/_jsx(FooterMicrocopy, {})]
      }), /*#__PURE__*/_jsx(PhoneSupportFooter, {
        phoneSourceId: "crmsuite-footer",
        screen: screen,
        upgradeProduct: BUNDLE
      })]
    })]
  });
};
export default MobileSuitePage;